import React from 'react';
import { Box, Button, Chip, Paper, Stack, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  SMART_COLORS as COLORS,
  smartCardSx as cardSx,
} from '../theme/smartStableTheme';

const SettingsPageHeader = ({
  title,
  subtitle,
  count,
  countLabel,
  actions,
  backTo = '/settings',
}) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === 'ar';

  return (
    <Paper elevation={0} sx={{ ...cardSx, p: { xs: 2, md: 3 }, mb: 2.5 }}>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        justifyContent="space-between"
        alignItems={{ xs: 'stretch', md: 'center' }}
        gap={2}
      >
        <Box>
          <Typography variant="h4" sx={{ color: COLORS.text, fontWeight: 900 }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography sx={{ color: COLORS.muted, mt: 0.5 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
        <Stack
          direction="row"
          spacing={1}
          flexWrap="wrap"
          useFlexGap
          alignItems="center"
          justifyContent={{ xs: 'flex-start', md: 'flex-end' }}
        >
          {typeof count !== 'undefined' && (
            <Chip
              label={`${count} ${countLabel || t('records', 'records')}`}
              sx={{ bgcolor: COLORS.goldSoft, fontWeight: 900 }}
            />
          )}
          <Button
            variant="outlined"
            onClick={() => navigate(backTo)}
            startIcon={!isRtl ? <ArrowBackIcon /> : null}
            endIcon={isRtl ? <ArrowBackIcon /> : null}
            sx={{
              borderColor: COLORS.line,
              color: COLORS.text,
              fontWeight: 900,
              bgcolor: COLORS.card,
            }}
          >
            {t('back_to_settings', 'Back to Settings')}
          </Button>
          {actions}
        </Stack>
      </Stack>
    </Paper>
  );
};

export default SettingsPageHeader;
